export interface BarGraphSourceReportParameter {
   value: ReportBarGraphSource;
}

export enum ReportBarGraphSource {
   'Count' = 'Count',
   'Duration' = 'Duration',
}
